import { PersonAddAlt, PersonPinCircleOutlined } from "@mui/icons-material";
import { Button, Card, Container, IconButton, Stack, Tooltip, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import DataTable from "react-data-table-component";
import CustomLoader from "src/components/CustomLoader";
import Page from "src/components/Page";
import { Routes } from "src/constant/api_url";
import { getPrimeAchievementPinList } from "src/api/primestockapi";

export default function Index() {
  const navigate = useNavigate();
  const [tableData, setTableData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const { state } = useLocation();

  const columns = [
    {
      name: "No",
      wrap: true,
      selector: (row) => row?.a_p_id,
      sortable: true,
      width: "100px"
    },
    {
      name: "Name",
      wrap: true,
      selector: (row) => row?.name,
      sortable: true
    },
    {
      name: "Image",
      selector: (row) => (
        <>
          <img
            title={row.name}
            src={`${Routes.API_HOSTNAME}prime-pin-image/${row?.image}`}
            width="90"
            alt={row.name}
          />
        </>
      ),
      sortable: true
    },
    {
      name: "Pin Description",
      selector: (row) => row?.description,
      wrap: true,
      sortable: true
    },
    {
      name: "Price",
      selector: (row) => (parseFloat(row?.p_price) > 0 ? `₹${row.p_price}` : "Free"),
      wrap: true,
      sortable: true,
      width: "110px"
    },
    {
      name: "Action",
      wrap: true,
      sortable: true,
      width: "180px",
      selector: (row) => (
        <>
          {/* Both actions open the same member list for this pin's product.
              They differ only in which tab lands selected: 0 = Eligible,
              1 = Assign. The full shape (p_id + p_a_p_id + p_name + p_type)
              is always passed so memberList can resolve the product on its
              first query. */}
          <Tooltip title="Pin Eligible Users">
            <IconButton
              onClick={() => {
                navigate("/pininmemberlist", {
                  state: {
                    p_id: row.p_id,
                    p_name: row.name,
                    p_type: 1,
                    p_a_p_id: row.a_p_id,
                    tab: 0
                  }
                });
              }}
            >
              <PersonPinCircleOutlined color="success" />
            </IconButton>
          </Tooltip>
          <Tooltip title="Assign Member">
            <IconButton
              onClick={() => {
                navigate("/pininmemberlist", {
                  state: {
                    p_id: row.p_id,
                    p_name: row.name,
                    p_type: 1,
                    p_a_p_id: row.a_p_id,
                    tab: 1
                  }
                });
              }}
            >
              <PersonAddAlt color="primary" />
            </IconButton>
          </Tooltip>
        </>
      )
    }
  ];

  const getPinBadge = async () => {
    setIsLoading(true);
    const res = await getPrimeAchievementPinList();
    setIsLoading(false);
    setTableData(res?.status == 1 ? res.data || [] : []);
  };

  useEffect(() => {
    getPinBadge();
  }, []);

  const selectedPin = state?.a_p_id
    ? (tableData ?? []).find((row) => row.a_p_id === state.a_p_id)
    : null;

  return (
    <>
      <Page title="Pin In Member | Local Vocal Business Group">
        <Container>
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
            <Typography variant="h4" gutterBottom>
              Pin In Member
            </Typography>
            <Button variant="contained" onClick={() => navigate("/products")}>
              Back to Products
            </Button>
          </Stack>

          {selectedPin && (
            <Stack direction="row" alignItems="center" spacing={2} mb={2}>
              <img
                src={`${Routes.API_HOSTNAME}prime-pin-image/${selectedPin?.image}`}
                width="48"
                alt={selectedPin?.name}
              />
              <Typography variant="h6">Selected Pin: {selectedPin?.name}</Typography>
            </Stack>
          )}

          <Card spacing={3} style={{ padding: "10px", marginTop: "20px" }}>
            <DataTable
              filter
              pagination
              highlightOnHover
              columns={columns}
              data={tableData != null ? tableData : []}
              progressPending={isLoading}
              progressComponent={<CustomLoader />}
              conditionalRowStyles={[
                {
                  when: (row) => selectedPin && row.a_p_id === selectedPin.a_p_id,
                  style: { backgroundColor: "#e5eeff" }
                }
              ]}
            />
          </Card>
        </Container>
      </Page>
    </>
  );
}
